// @ts-nocheck
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export function CustomerTrendChart({ data, period }) {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white p-4 rounded-lg shadow">
        <p className="text-center text-gray-500">データがありません</p>
      </div>
    );
  }

  const chartData = {
    labels: data.map(d => formatDate(d.date, period)),
    datasets: [
      {
        label: '新規顧客数',
        data: data.map(d => d.count),
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fill: true,
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const
      },
      title: {
        display: true,
        text: '顧客数推移'
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div style={{ height: '300px' }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}

function formatDate(dateStr, period) {
  const date = new Date(dateStr);
  if (period === '7d' || period === '30d') {
    return `${date.getMonth() + 1}/${date.getDate()}`;
  } else if (period === '90d') {
    return dateStr; // YYYY-MM-DD-W1形式
  } else {
    return `${date.getFullYear()}/${date.getMonth() + 1}`;
  }
}
